/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authenticationRevokeAccessToken } from "../../funcs/authenticationRevokeAccessToken.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.RevokeTokenRequest$inboundSchema,
};

export const tool$authenticationRevokeAccessToken: ToolDefinition<typeof args> =
  {
    name: "authentication-revoke-access-token",
    description: `Revoke an auth token.

Allows clients to notify the authorization server that a previously obtained refresh or access token is no longer needed.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await authenticationRevokeAccessToken(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(void 0, apiCall);
    },
  };
